/**
 * The wait of the title step : the photos of the album shuffle in a stack, sparkles rise from it and
 * three shimmering lines stand for the titles being written, while a status line tells what is going
 * on and a bar fills along the bottom edge.
 *
 * The wait lasts as long as the suggestions take (the templates, the geocoding and Claude, 2 to 10
 * seconds) : the bar is eased towards 90% and only reaches the end on finish(), and the status line
 * holds on its last message rather than following a duration of its own.
 */
fx.ns("shared.screens.magic", class WaitingTitles extends fx.components.Box {

    constructor(photos, count)
    {
        super("WaitingTitles");

        this._photos = (photos || []).slice(0, 3);
        this._count = count || this._photos.length;   // the album's photos, of which the stack shows three
        this._index = 0;
        this._progress = 4;
    }

    get messages()
    {
        return [
            fx.text("On feuillette vos $ photos…", this._count),
            fx.text("On repère les moments forts…"),
            fx.text("On imagine 3 titres…")
        ];
    }

    render()
    {
        let cards = "";

        for (let i = 0; i < 3; i++)
        {
            let photo = this._photos[i];
            cards += '<div class="card card' + (i + 1) + '">' + (photo ? '<img src="' + photo + '">' : "") + '</div>';
        }

        return '<div class="stack">' + cards +
                    '<span class="sparkle sparkle1"></span><span class="sparkle sparkle2"></span>' +
                    '<span class="sparkle sparkle3"></span><span class="sparkle sparkle4"></span>' +
                '</div>' +
                '<div class="skeleton"><span class="line line1"></span><span class="line line2"></span><span class="line line3"></span></div>' +
                '<div class="status"><span class="message"></span></div>' +
                '<div class="progress"><span class="bar"></span></div>';
    }

    onReady()
    {
        super.onReady();

        this._start = Date.now();
        this._write(this.messages[0]);
        this._draw();

        this.repeat(this._next, 1600);
        this.repeat(this._tick, 150);
    }

    /** Milliseconds since the animation appeared, what the step counts its minimum on. */
    get elapsed()
    {
        return this._start ? (Date.now() - this._start) : 0;
    }

    /** Longer than expected : the status line stops turning and reassures. */
    slow()
    {
        this.repeat(this._next, null);
        this._write(fx.text("C'est plus long que prévu, on y est presque…"));
    }

    /**
     * The photos are still being imported : nothing can be written about an album we have not seen
     * yet, so the line says what is going on and stops turning until resume().
     */
    importing()
    {
        this.repeat(this._next, null);
        this._write(fx.text("Je récupère vos photos"));
    }

    /**
     * The photos are all there : the animation goes back to its own messages, with the album's real
     * count and its first pictures, neither of which was known when the import started.
     */
    resume(count, photos)
    {
        this._count = count || this._count;
        this._photos = (photos && photos.length) ? photos.slice(0, 3) : this._photos;
        this._index = 0;

        this._fillCards();
        this._write(this.messages[0]);
        this.repeat(this._next, 1600);
    }

    /** The stack shows the photos of the album : empty at first when the import is still running. */
    _fillCards()
    {
        for (let i = 0; i < 3; i++)
        {
            let card = this.find(".card" + (i + 1));
            let photo = this._photos[i];

            if (!card)
                continue;

            if (photo)
                card.innerHTML = '<img src="' + photo + '">';
            else
                card.innerHTML = "";
        }
    }

    /** The titles are there : the bar is filled, then the caller is free to show them. */
    finish(callback)
    {
        this.repeat(this._next, null);
        this.repeat(this._tick, null);

        this._progress = 100;
        this._draw();

        this.delay(callback, 260);
    }

    _next()
    {
        if (this._index >= this.messages.length - 1)
        {
            this.repeat(this._next, null);
            return;
        }

        this._write(this.messages[++this._index]);
    }

    // the message fades out, is replaced, and fades back in (the css carries the transition)
    _write(text)
    {
        let node = this.find(".message");

        if (!node)
            return;

        if (!node.innerHTML)
        {
            node.innerHTML = text;
            return;
        }

        node.classList.add("out");

        this.delay(() => {
            let message = this.find(".message");

            if (!message)
                return;

            message.innerHTML = text;
            message.classList.remove("out");
        }, 300);
    }

    // eased towards 90% : a bar reaching the end before the titles do reads as a bug
    _tick()
    {
        this._progress = 4 + 86 * (1 - Math.exp(-this.elapsed / 3500));
        this._draw();
    }

    _draw()
    {
        let bar = this.find(".bar");

        if (bar)
            bar.style.width = Math.min(100, Math.round(this._progress)) + "%";
    }
});
